import React, { useContext, useEffect, useRef, useState } from "react";
import PathShow from "../components/layout/PathShow";
import RequestBeforeBuy from "../components/common/requestForm/RequestBeforeBuy";
import ProductSlider from "../components/common/ProductSlider";
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import RequestBuy from "../components/common/requestForm/RequestBuy";
import Compare from "../components/layout/Compare";
import { httpReauest } from "../utils/httpRequest";
import { getTiming } from "../utils/getTiming";
import { Helmet } from "react-helmet";
import Modal from "@mui/material/Modal";
import ShareModal from "../components/common/mobile/ShareModal";
import { CDN_BASE_URL } from "../config";
import { FaCheck, FaTimes } from "react-icons/fa";
import { ProductContext } from "../context/ProductContext";
import NotFound from "./404NotFound";
import { priceComma } from "../utils/priceComma";
import ArrowDownIcon from "../icons/ArrowDownIcon";
import { ExpertContext } from "../context/ExpertContext";
import ProductsFromModel from "../components/common/products/ProductsFromModel";
import BlogsRelated from "../components/common/mobile/BlogsRelated";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "#fff",
  boxShadow: 24,
  borderRadius: 10,
};

const ProductDetailPage = ({ setchat, dealerData }) => {
  const { name, category, brand, vehicle_number } = useParams();
  const [loading, setLoading] = useState();
  const [share, setShare] = useState();
  const [related, setrelated] = useState([]);
  const [selected, setselected] = useState();
  const [show, setshow] = useState();
  const [error, seterror] = useState();
  const [blogs, setblogs] = useState();
  const [content, setcontent] = useState();
  const naviagte = useNavigate();

  const { setselectProduct, selectProduct } = useContext(ProductContext);

  const { expertUser, setexpertUser } = useContext(ExpertContext);

  const url = `https://1924.ir/${category}/${brand}/${name}/${vehicle_number}`;

  useEffect(() => {
    getData();
  }, [name]);

  async function getData() {
    setLoading(true);
    await httpReauest(
      "GET",
      `/vehicle/details/${category}/${brand}/${name}/${vehicle_number}`,
      {},
      {}
    )
      .then(({ data }) => {
        setselected(data?.data?.vehicle);
        setcontent(data?.data?.url);
        setrelated(data?.data?.related);
        setblogs(data?.data?.blogs);
      })
      .catch(() => {
        if (name.includes(brand)) {
          let result = name.replace(brand, "").replace(/^-/, "");
          naviagte(`${category}/${brand}/${result}`);
        }
      });
    setLoading(false);
  }

  const ref = useRef(null);
  const ref2 = useRef(null);
  const refinside = useRef(null);

  const now = new Date();
  const newTime = now.getTime() - new Date(selected?.createdAt).getTime();
  const hour = newTime / 86400000;

  // useEffect(() => {
  //   if (offset?.current?.offsetTop - ref2?.current?.offsetTop > 0) {
  //     setTimeout(() => {
  //       ref2.current.scroll({
  //         top: offset?.current?.offsetTop - ref2?.current?.offsetTop,
  //         behavior: "smooth",
  //       });
  //     }, 800);
  //   }
  // }, [selected]);

  if (error) {
    return <NotFound />;
  }

  return (
    <div className="container_1 py-4 w-full">
      {share && (
        <Modal
          open={share}
          onClose={() => setShare(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div dir="rtl" style={style}>
            <ShareModal desktop url={url} setShare={setShare} />
          </div>
        </Modal>
      )}
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          {selected?.meta_title ? selected?.meta_title : selected?.name}
        </title>
        <meta
          name="description"
          content={
            selected?.meta_desc
              ? selected?.meta_desc
              : `آگهی فروش ${selected?.name}`
          }
        />
        <meta name="keywords" content={content?.meta_keywords} />
        <meta
          name="og:description"
          content={
            selected?.meta_desc
              ? selected?.meta_desc
              : `آگهی فروش ${selected?.name}`
          }
        />
        <meta
          name="og:title"
          content={selected?.meta_title ? selected?.meta_title : selected?.name}
        />
        <link rel="canonical" href={url} />
      </Helmet>{" "}
      <div className="mb-12">
        <PathShow
          name={selected?.name}
          category={content?.category?.name}
          brand={content?.brand?.title}
          categoryId={category}
          brandId={brand}
        />
      </div>
      <RequestBeforeBuy
        file={selected?.file && CDN_BASE_URL + selected?.file}
      />
      <div className="grid grid-cols-5 my-12 gap-5">
        <span className="col-span-2 ">
          <ProductSlider
            data={selected?.images}
            img={selected?.img}
            name={selected?.name}
          />
        </span>
        <span
          ref={ref2}
          className="col-span-2 max-h-[460px] xl:max-h-[520px] pl-3 overflow-y-scroll"
        >
          <div className="flex justify-between items-center">
            <h1 className="title">{selected?.name}</h1>
            <span className="flex gap-3 items-center">
              <p>{getTiming(hour)}</p>
              <img
                onClick={() => setShare(true)}
                src="/share.png"
                className="w-[22px]"
                alt="Share"
              />
            </span>
          </div>
          <div className="flex flex-col gap-2 py-4">
            <>
              <div
                className={`grid overflow-hidden duration-[500ms] grid-cols-2  gap-3 ps-3 text-[16px]`}
              >
                {selected?.details?.map((item) => {
                  if (item?.name !== "") {
                    return (
                      <span className="flex gap-2 items-start  ">
                        <span className="font-bold whitespace-nowrap relative yellow-circle-small">
                          {item?.name}:
                        </span>{" "}
                        <span>{item?.value}</span>
                      </span>
                    );
                  }
                })}
                {expertUser ? (
                  <>
                    <span className="flex gap-2 items-start ">
                      <span className="font-bold  relative yellow-circle-small">
                        اسم کارشناس:
                      </span>{" "}
                      <span>{selected?.expert_name}</span>
                    </span>
                    <span className="flex gap-2 items-start ">
                      <span className="font-bold  relative yellow-circle-small">
                        شماره تماس کارشناس:
                      </span>{" "}
                      <span>{selected?.expert_phone}</span>
                    </span>
                  </>
                ) : null}
                <div className="flex justify-between flex-row-reverse w-full col-span-full -ms-3">
                  {selected?.desc && selected?.desc.length > 60 && !show && (
                    <button
                      id="show_p"
                      className="text-blue-600 whitespace-nowrap "
                    >
                      مشاهده بیشتر
                    </button>
                  )}

                  <p className={`text-[#8E9192]  paragraph text-right w-full`}>
                    {selected?.desc}
                  </p>
                </div>
              </div>
            </>
          </div>
        </span>
        <span className="col-span-1">
          <div className="w-full border-brand flex flex-col items-center justify-center p-3 gap-3">
            <p className="text-[#5C5F5F]">
              {selected?.rate ? "کارشناسی شده" : "قیمت اعلامی مالک"}
            </p>
           
              <div className="grid grid-cols-3 w-full rounded-full relative">
                <span className="bg-red-600 p-1 "></span>
                <span className="bg-yellow-500 p-1"></span>
                <span className="bg-green-600 p-1"></span>
                {selected?.rate ? (
                  <span
                    style={{ right: selected?.rate + "%" }}
                    className={`absolute w-[17px] h-[17px] top-[-52%] rounded-full bg-[#00000070] border-double border-[3px] border-white z-10`}
                  ></span>
                ) : null}
              </div>

            <p className="text-[#5C5F5F] mt-3 text-[14px]">
              {!selected?.rate
                ? ""
                : selected?.rate > 66
                ? " قیمت این خودرو منصفانه است!"
                : selected?.rate > 33
                ? "قیمت این خودرو عادی است"
                : "قیمت خودرو منصفانه نیست"}
            </p>
          </div>
          <div className="py-5">
            <h2 className="text-[24px] text-green-600 text-center">
              {selected?.no_price ? (
                "توافقی"
              ) : (
                <>
                  قیمت{" "}
                  <strong className="text-[36px]">
                    {selected?.price >= 1
                      ? selected?.price
                      : selected?.price * 1000}
                  </strong>
                  {selected?.price < 1 ? "میلیون" : "میلیارد"} تومان
                </>
              )}
            </h2>
          </div>
          <div className="flex flex-col gap-3">
            <Link className="btn-brand">اکنون بخر</Link>
            <button className="btn-brand" onClick={() => setchat(true)}>
              چت
            </button>
            <Link to={"/compare"} className="btn-brand-outline">
              مقایسه با خودرو های دیگر
            </Link>
          </div>
        </span>
      </div>
      <RequestBuy />
      {/* <div ref={ref}>
        <Compare
          dealerData={dealerData}
          setselected={setselected}
          selectProduct={selected?._id}
          keys={content?.details}
          data={products}
        />
      </div> */}
      <div className="my-12">
        <h1 className="title">{content?.title}</h1>
        <div
          className="desc_details overflow-x-scroll"
          dangerouslySetInnerHTML={{ __html: content?.content }}
        />
      </div>
      <div className="my-12">
        {related.length && (
          <ProductsFromModel data={related} title={"محصولات مرتبط"} />
        )}
      </div>
      <div>
        <h3 className="title">آخرین مقالات</h3>
        <div className="grid grid-cols-3 xl:grid-cols-4 gap-5 mt-4">
          <BlogsRelated related={blogs} />
        </div>
      </div>
    </div>
  );
};

export default ProductDetailPage;
